export default function Family() {
  return (
    <div
      className="bg-center py-20 text-center bg-cover"
      style={{ backgroundImage: `url(${require("./img/bg.png")})` }}
    >
      <div className="container mx-auto text-white">
        <p className="text-2xl md:text-4xl font-cookie-black uppercase">
          Let’s join our great family!
        </p>
        <p className="mt-2">Grow and share value together!</p>
        <img
          src={require("./img/data.png")}
          className="w-full mt-4 hidden md:block"
        />
        <img
          src={require("./img/data-mb.png")}
          className="w-full mt-4 md:hidden"
        />
      </div>
    </div>
  );
}
